<ng-select
  class="mercado-select listas"
  [items]="itemsVista"
  bindValue="idmercado"
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  [clearable]="clearable"
  [searchable]="searchable"
  [disabled]="disabled"
  [placeholder]="placeholder"
  appendTo="body"
  (open)="refrescarItems()">

  <ng-template ng-label-tmp let-item="item">
    <i *ngIf="seleccionada?.disabled" class="ri-lock-line mercado-select__lock"
       [attr.title]="motivoBloqueo(seleccionada)"></i>
    {{ label(item) }}
    <span *ngIf="item?.metaapi" class="mercado-select__tag">MetaTrader</span>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <div class="mercado-select__option"
         [class.mercado-select__option--bloqueada]="item?.disabled"
         [attr.title]="item?.disabled ? motivoBloqueo(item) : null"
         (click)="avisarSiBloqueada(item)">
      <i *ngIf="item?.disabled" class="ri-lock-line mercado-select__lock"></i>
      <span class="mercado-select__text">{{ label(item) }}</span>
      <span *ngIf="item?.metaapi" class="mercado-select__tag">MetaTrader</span>
      <span *ngIf="esEditable(item)"
            class="mercado-select__edit"
            role="button"
            title="Editar esta lista de mercado"
            (click)="editarLista(item, $event)">
        <i class="ri-pencil-line"></i>
      </span>
    </div>
  </ng-template>

</ng-select>
